let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dWFQg")).then(() => parcelRequire('6FING'));